export function afterNextPaint(callback: () => void): void {
  // Runs `callback` after one DOM content frame has actually been painted.
  // `requestAnimationFrame` fires  just BEFORE next paint, so executing twice runs callback after next paint.
  // Seemingly currently the best way to do this.
  requestAnimationFrame(() => requestAnimationFrame(callback));
}
